import React from "react";
import { useStore } from "../../../store/store";

function findCentorSectionViews(material: string, sill: string) {
  const folder = "CENTOR_SECTION_VIEW/sliders";
  const materialLabel = material === "All Wood" ? "WOOD" : "CLAD";
  const sillLabel = sill.includes("Steel") ? "TRACKS" : "SILL";

  let headSill = `${folder}/${materialLabel}_${sillLabel}`;
  let jambLeg = `${folder}/${materialLabel}_LEG_JAMB`;

  if(materialLabel === "CLAD"){
    headSill += "_v2"
    jambLeg += "_v2"
  }

  return {
    headSill,
    jambLeg
  };
}

function useScreenTypeSelector(arrayLength: number) {
  const addToQuote = useStore((state) => state.addToQuote);

  const screenTypeChoice = useStore((state) => state.quote.screenType);

  const material = useStore((state) => state.quote.material);

  const sillStyle = useStore((state) => state.quote.sillStyle);

  const isCentor = screenTypeChoice?.includes("Centor");

  const isBrio = screenTypeChoice?.includes("Brio");

  const centorImgs = isCentor
    ? findCentorSectionViews(material, sillStyle || "")
    : null;

  const handleClick = (label: string) => {
    const checked = label === screenTypeChoice;

    if (checked) {
      addToQuote(
        {
          screenType: "",
          addScreen: "",
          screenLayout: "",
          screenPocket: "",
          screenColor: "",
        },
        "addScreen"
      );
    } else {
      addToQuote(
        {
          screenType: label,
          addScreen: "",
          screenLayout: "",
          screenPocket: "",
          screenColor: "",
        },
        "addSlidingScreen"
      );
    }
  };

  const brioOnlyOption = arrayLength === 1 ? true : false;

  return {
    brioOnlyOption,
    handleClick,
    centorImgs,
    isBrio,
    isCentor,
    screenTypeChoice
  };
}

export default useScreenTypeSelector;
